var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportIconDarkSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 20.375H19.6666M9.33325 14.875H17.0833M10.6249 3.1875H5.45825V25.875H23.5416V3.1875H18.3749M10.6249 3.1875V5.25H18.3749V3.1875M10.6249 3.1875V1.125H18.3749V3.1875",
    stroke: "#00B7FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 30,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportIconDarkSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reportIcon_dark_selected.2ec67b35a044d56febb8831f5c5457f2.svg";